module.exports = __webpack_public_path__ + "img/xc.caa9f042.gif";